import { Autocomplete, CircularProgress, TextField, Typography } from "@mui/material";
import { id } from "date-fns/locale";
import React, { useEffect, useMemo, useState } from "react";
import { EquipmentData } from "../../../types/api/equipment";
import { useParams } from "react-router-dom";
import { getEquipments } from "../../../api/equipmentAPI";
import { LIMIT_FIELD, PAGE_FIELD } from "../../../constants/common";
import { AsynchronousEquipmentProps } from "../../../types/common";
import useDebounce from "../../../utils/useDebounce";

interface Props extends Omit<AsynchronousEquipmentProps, "value"> {
    value?: string;
    options?: Array<EquipmentData>;
}

export const AsynchronousEquipment = ({ onChange, value, options }: Props) => {
    const [select, setSelect] = useState<EquipmentData>();

    useEffect(() => {}, [value]);

    const selectedValues = useMemo(() => options?.find(v => v.id === Number(value)), [options, value]);

    return (
        <Autocomplete
            fullWidth
            value={select ?? selectedValues}
            onChange={(_event, newValue: EquipmentData | null) => {
                if (newValue?.id) {
                    setSelect(newValue);
                    onChange(newValue);
                }
            }}
            noOptionsText={"Нет совпадений"}
            // isOptionEqualToValue={(option, value) => option.name === value.name}
            getOptionLabel={option => option.name}
            options={options ?? []}
            // inputValue={query ?? ""}
            // onInputChange={(_event, newInputValue) => {
            //     setQuery(newInputValue);
            // }}
            renderOption={(props, option) => {
                return (
                    <li {...props} key={typeof option === "string" ? option : option.id}>
                        <Typography gutterBottom>{typeof option === "string" ? option : option.name ?? ""}</Typography>
                    </li>
                );
            }}
            renderInput={params => (
                <TextField
                    {...params}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            )}
        />
    );
};
